import BulkUpdate from "./bulkUpdate"
export default BulkUpdate